<template>
  <div class="min-vh-100 bg-light">
    <!-- Header với gradient -->
    <div class="d-flex flex-column flex-fill text-white header-gradient">
      <!-- Header Content -->
      <div class="d-flex align-items-center position-relative shadow px-4 py-3" style="background-color: #2563EB;">
        <img
          :src="require(`@/assets/logo.png`)"
          alt="logo"
          class="me-4"
          style="width: 45px; height: 45px;"
        />
        <div class="w-100 text-center">
          <p class="fs-3 fw-semibold mb-1">TRUNG TÂM PHỤC VỤ HÀNH CHÍNH CÔNG PHƯỜNG TÂN HƯNG</p>
          <p class="mb-0 opacity-75">
            Quý khách vui lòng đánh giá chất lượng phục vụ
          </p>
        </div>
      </div>
      
      <div class="container-fluid py-4 d-flex flex-column flex-grow-1 justify-content-center align-items-center">
        <div class="row g-4">
          <!-- Current Number Section -->
          <div class="col-4">
            <div class="d-flex flex-column align-items-center h-100">
              <p class="text-uppercase fw-bold fs-2 mb-3">{{ boothInfo.cTenQuay }}</p>
              <div class="bg-white rounded-4 shadow p-4 d-flex flex-column align-items-center justify-content-center w-100 h-100">
                <p class="text-uppercase mb-2 fs-4 text-black" style="color: #000;">Số hiện tại</p>
                <p class="fw-bold mb-3 text-primary" style="font-size: 84px;">{{ currentData ? currentData.cSoThuTu : "---" }}</p>
                <p class="fs-4 text-muted">Thời gian ước tính: ~10 phút</p>
              </div>
            </div>
          </div>

          <div class="col-8">
            <!-- Rating Section -->
            <div class="h-100 d-flex flex-column">
              <p class="text-uppercase fw-bold fs-2 mb-3 text-center">Đánh giá dịch vụ</p>
              <div class="row g-4 flex-grow-1">
                <div
                  v-for="option in ratingOptions"
                  :key="option.id"
                  class="col-6"
                >
                  <div
                    class="bg-white rounded-4 shadow p-4 d-flex flex-column align-items-center h-100"
                    :style="{ border: '2px solid', borderColor: option.color, cursor: 'pointer' }"
                    @click="handleRating(option)"
                  >
                    <i :class="[option.icon]" style="font-size: 24vh;"></i>
                    <p
                      class="fw-bold mt-3 mb-0 text-center"
                      :style="{ color: option.color, fontSize: '24px' }"
                    >
                      {{ option.label }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>

    <!-- Overlay and Notification -->
    <template v-if="showNotification">
      <!-- Dark Overlay -->
      <div 
        class="position-fixed top-0 start-0 w-100 h-100" 
        style="background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(2px); z-index: 1049;"
      ></div>
      
      <!-- Notification -->
      <div
        class="position-fixed top-50 start-50 translate-middle"
        style="z-index: 1050;"
      >
        <div
          class="bg-white rounded-3 shadow-lg px-4 py-6 text-center w-100"
          style="min-width: 350px; animation: fadeInUp 0.3s ease-out;"
        >
          <div class="mb-3">
            <i class="fas fa-check-circle text-success" style="font-size: 56px;"></i>
          </div>
          <h4 class="fw-bold mb-2 fs-1" style="color: #2563EB;">Cảm ơn quý khách!</h4>
          <p class="text-muted mb-0 fs-6">
            Cảm ơn quý khách đã đánh giá chất lượng dịch vụ.
            <br />Chúng tôi sẽ không ngừng cải thiện để phục vụ quý khách tốt hơn.
          </p>
        </div>
      </div>
    </template>


    <!-- Overlay and Notification -->
    <template v-if="showWarning">
      <!-- Dark Overlay -->
      <div 
        class="position-fixed top-0 start-0 w-100 h-100" 
        style="background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(2px); z-index: 1049;"
      ></div>
      
      <!-- Notification -->
      <div
        class="position-fixed top-50 start-50 translate-middle"
        style="z-index: 1050;"
      >
        <div
          class="bg-white rounded-3 shadow-lg px-4 py-6 text-center w-100"
          style="min-width: 350px; animation: fadeInUp 0.3s ease-out;"
        >
          <div class="mb-3">
            <i class="fas fa-exclamation-circle text-warning" style="font-size: 56px;"></i>
          </div>
          <h4 class="fw-bold mb-2 fs-1 text-warning">Phiên đánh giá không hợp lệ!</h4>
          <p class="text-muted mb-0 fs-6">
            Lượt đánh giá của Quý khách không hợp lệ do:
            <br />- Chưa đến thời gian làm việc
            <br />- Thời gian làm việc đã kết thúc
          </p>
        </div>
      </div>
    </template>

    <!-- Overlay and Already Rated Notification -->
    <template v-if="showAlreadyRated">
      <!-- Dark Overlay -->
      <div 
        class="position-fixed top-0 start-0 w-100 h-100" 
        style="background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(2px); z-index: 1049;"
      ></div>
      
      <!-- Notification -->
      <div
        class="position-fixed top-50 start-50 translate-middle"
        style="z-index: 1050;"
      >
        <div
          class="bg-white rounded-3 shadow-lg px-4 py-6 text-center w-100"
          style="min-width: 350px; animation: fadeInUp 0.3s ease-out;"
        >
          <div class="mb-3">
            <i class="fas fa-info-circle text-info" style="font-size: 56px;"></i>
          </div>
          <h4 class="fw-bold mb-2 fs-1 text-info">Đã đánh giá!</h4>
          <p class="text-muted mb-0 fs-6">
            Bạn đã đánh giá dịch vụ này rồi.
          </p>
        </div>
      </div>
    </template>

    <!-- Loading Overlay -->
    <template v-if="isLoading">
      <!-- Dark Overlay -->
      <div 
        class="position-fixed top-0 start-0 w-100 h-100" 
        style="background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(2px); z-index: 1049;"
      ></div>
      
      <!-- Loading Spinner -->
      <div
        class="position-fixed top-50 start-50 translate-middle"
        style="z-index: 1050;"
      >
        <div class="loading-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="text-white mt-3">Đang xử lý...</div>
        </div>
      </div>
    </template>

  </div>
</template>

<script setup>

  import store from '@/store';
  import { Actions, Booth, QueueNumber, Rating } from "@/store/enums/StoreEnums";
  import { onMounted, onUnmounted, ref } from "vue";
  import { TOPICS } from '@/websocket/topics';
  import { subscribe, unsubscribe } from '@/websocket/stompService';
import { CookieComponent } from '@/assets/ts/components';
import JwtService from '@/core/services/JwtService';
import ApiService from '@/core/services/ApiService';

  const currentNumber = ref("---");
  const ratingOptions = [
    { id: 4, label: "Rất hài lòng", icon: "fas fa-grin-stars fa-4x text-success", color: "#28a745" },
    { id: 3, label: "Hài lòng", icon: "fas fa-smile fa-4x text-primary", color: "#1b84ff" },
    { id: 2, label: "Bình thường", icon: "fas fa-meh fa-4x text-warning", color: "#ffc107" },
    { id: 1, label: "Không hài lòng", icon: "fas fa-frown fa-4x text-danger", color: "#dc3545" },
  ];
  const showNotification = ref(false);
  const showWarning = ref(false);
  const showAlreadyRated = ref(false);
  const isLoading = ref(false);
  const selectedRating = ref(null);
  const currentData = ref(null);
  const boothInfo = ref({cTenQuay: ""});

  const SIX_HOURS_IN_MS = 6 * 60 * 60 * 1000;
  // const SIX_HOURS_IN_MS = 10 * 1000;
  let loginInterval = null;

  const loadFirstData = async () => {
    const booth = await store.dispatch(Booth.getByUserReview, {});
    if(booth.code == 200 && booth.data) {
      boothInfo.value = booth.data;
    }
    const data = await store.dispatch(QueueNumber.getProcessingQueueByBooth, {});
    if(data.code == 200 && data.data)
      currentData.value = data.data;
    else
      currentData.value = null;
  }

  const refreshData = (data) => {
    const result = JSON.parse(data.body);
    if(result.code == 200 && result.data)
      currentData.value = result.data;
    else
      currentData.value = null;
  }


  const reLogin = async () => {
    try {
      const result = await store.dispatch(Actions.RE_LOGIN, {});      
      if (result.code == 200 && result.data) {
        await JwtService.saveToken(result.data);
        await ApiService.setHeader();
      }
    } catch (error) {
      console.error('Lỗi khi tự động đăng nhập lại:', error)
    }
  }


  onMounted( async () => {
    loadFirstData();
    subscribe("/topic/" + CookieComponent.get("userName") + "/process-number", refreshData);
    loginInterval = setInterval(reLogin, SIX_HOURS_IN_MS)
  });

  onUnmounted(() => {
    unsubscribe("/topic/" + CookieComponent.get("userName") + "/process-number", refreshData);
    if (loginInterval) {
      clearInterval(loginInterval)
    }
  });

const handleRating = async (rating) => {
  if(!currentData.value) {
    showWarning.value = true;
    setTimeout(() => {
      showWarning.value = false;
    }, 3000);    
    return;
  }

  // Bắt đầu loading
  isLoading.value = true;

  try {
    const data = {
      cNoiDung: rating.label,
      nDanhGia: rating.id,
      nMaNhatKy: currentData.value.nMa,
    }
    const result = await store.dispatch(Rating.saveRating, data);
    
    isLoading.value = false;

    if (result.code === 200) {
      showNotification.value = true;
      setTimeout(() => {
        showNotification.value = false;
      }, 3000);      
    } else {
      showAlreadyRated.value = true;
      setTimeout(() => {
        showAlreadyRated.value = false;
      }, 3000);
    }
  } catch (error) {
    isLoading.value = false;
    showAlreadyRated.value = true;
    setTimeout(() => {
      showAlreadyRated.value = false;
    }, 3000);
  }
};
</script>

<style scoped>
.header-gradient {
  background: linear-gradient(135deg, #1b84ff, #f1416c);
  min-height: 100vh;
}

.rounded-4 {
  border-radius: 1rem !important;
}

.container-fluid {
  max-width: 1600px;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 20px));
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

[v-if] {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.spinner-ring {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #ffffff;
  animation: spin 1s linear infinite;
}

.spinner-ring:nth-child(2) {
  position: absolute;
  width: 45px;
  height: 45px;
  border-top-color: #1b84ff;
  animation-duration: 0.8s;
  animation-direction: reverse;
}

.spinner-ring:nth-child(3) {
  position: absolute;
  width: 30px;
  height: 30px;
  border-top-color: #f1416c;
  animation-duration: 0.6s;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
